import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Column, Row } from '@lux/components';
import { Text } from '@dls/web';
import { SubtitlePrimary, SubtitleSecondary } from '../Base';
import Spacing from '../Spacing';
import SimOnlyImg from '../../assets/images/exclusive-validation/sim-only.png';
import PayLaterImg from '../../assets/images/exclusive-validation/pay-later.png';
import ImagePlus from '../../assets/images/exclusive-validation/plus.jpg';
import { simOnlyTncUrl } from '../../config/links';
import useTranslate from '../../hooks/useTranslation';

const StyledImg = styled.img`
  width: 104px;
  height: 104px;
`;

const StyledImgPlus = styled.img`
  width: 80%;

  ${p => p.theme.media.lg`
    width: 100%;
  `};
`;

const StyledColumn = styled(Column)`
  margin-top: 12.5%;

  ${p => p.theme.media.lg`
    margin: auto 0;
  `};
`;

const StyledIcon = styled.span`
  float: left;
`;

const StyledUnorderedList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

const StyledListItem = styled.li`
  margin-right: ${p => p.theme.spacing(1)};
`;

const StyledSubtitleSecondary = styled(SubtitleSecondary)`
  padding-left: ${p => p.theme.spacing(6)};
`;

const Content = ({ button, showButton = true }) => {
  const { t } = useTranslate();

  return (
    <Fragment>
      <Spacing bottom={4} bottomMd={4}>
        <Row center="sm">
          <Column>
            <Row middle="sm">
              <Column sm={12} lg={true}>
                <StyledImg src={SimOnlyImg} alt="Image of Sim Only" />
              </Column>
              <Column sm={12} lg={true}>
                <Text>{t('SIM_ONLY_PLUS__PLAN')}</Text>
              </Column>
            </Row>
          </Column>
          <StyledColumn sm={2} lg={1}>
            <StyledImgPlus src={ImagePlus} alt="Image of Plus icon" />
          </StyledColumn>
          <Column>
            <Row middle="sm">
              <Column sm={12} lg={true}>
                <StyledImg src={PayLaterImg} alt="Image of Pay Later Icon" />
              </Column>
              <Column sm={12} lg={true}>
                <Text>{t('DEVICE_INSTALLMENT_PLAN')}</Text>
              </Column>
            </Row>
          </Column>
        </Row>
      </Spacing>
      <Text>
        {t('SIM_ONLY_PLUS_UPSELL_DESCRIPTION')}
        <Text type="link" href={simOnlyTncUrl}>
          {t('T&C')}.
        </Text>
      </Text>
      {showButton && button}
    </Fragment>
  );
};

Content.propTypes = {
  button: PropTypes.node,
  showButton: PropTypes.bool
};

export default Content;
